import CustomModal from "../../../core/components/ui/custom-modal.component"
import EditModuleForm from "./edit-module-form.component";

const EditModuleModal = ({module, handleRecordChange, openEdit, setOpenEdit}) => {
    const handleClose = () => setOpenEdit(false);
    
    return(
        <CustomModal  
            open={openEdit}
            handleClose={handleClose}
            title="Edit Module"
        >
            <EditModuleForm handleClose={handleClose} handleRecordChange={handleRecordChange} module={module}/>
        </CustomModal>
    )
}


export default EditModuleModal
